import { Component, ComponentChild, ComponentFactory, h } from 'preact';
import { Properties } from '../common';
import { ClassNames, classNames } from './classNames';
import { CssModule, StyleContext } from './types';

export interface WithStyles {
  tx: ClassNames;
}

export function withStyles(...cssModules: CssModule[]): any {
  return function <TProp extends Properties>(ComposedComponent: ComponentFactory<TProp>): any {
    return class WithStyles extends Component<TProp> {
      private readonly tx: ClassNames;

      constructor(props: TProp, context: StyleContext) {
        super(props, context);
        context.styles?.registerModules(cssModules);
        this.tx = classNames(...cssModules);
      }

      render(props: TProp): ComponentChild {
        return <ComposedComponent {...props} tx={this.tx} />;
      }
    };
  };
}
